/**
 * MobileScanPromo (Iter 71 Feedback)
 *
 * Promo-Card für die Mobile-Scan-Page.
 * – Auf Desktop: kompakter QR-Code zur direkten Öffnung auf dem Smartphone.
 * – Auf Mobile: prominenter „Jetzt scannen"-Button, der direkt zur /m/scan-Page
 *   navigiert.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { Camera, Smartphone, Zap } from 'lucide-react';
import useIsMobile from '@/utils/useIsMobile';

export default function MobileScanPromo() {
  const isMobile = useIsMobile();
  // QR-Code-Workaround (Iter 72 Feedback): Viele Dev-Hosts haben kein SPA-Fallback
  // in nginx und liefern bei /m/scan ein 404. Deshalb verlinken wir über die Root-
  // Route (/?scan=1), die clientseitig weiter zu /m/scan redirected.
  const url = `${window.location.origin}/?scan=1`;

  return (
    <div className="relative overflow-hidden rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 via-white to-emerald-50/30 p-4 sm:p-5"
      data-testid="mobile-scan-promo">
      <div className="flex items-center gap-4">
        {/* Icon + Text */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <div className="bg-emerald-500 text-white rounded-lg p-1.5 shrink-0">
              <Camera className="h-4 w-4" strokeWidth={2} />
            </div>
            <h3 className="text-sm sm:text-base font-bold text-slate-900">
              Belege per Smartphone scannen
            </h3>
          </div>
          <p className="text-xs sm:text-sm text-slate-600 mb-2 leading-relaxed">
            Quittung fotografieren → KI erkennt Vendor, Datum & Betrag automatisch.
            <span className="hidden sm:inline"> Mehrseitige Lieferantenrechnungen werden zusammengefasst.</span>
          </p>
          <div className="flex flex-wrap items-center gap-3 text-[11px] sm:text-xs text-slate-500">
            <span className="flex items-center gap-1"><Zap className="h-3 w-3 text-emerald-600" />~8 Sek pro Beleg</span>
            <span className="hidden sm:flex items-center gap-1"><Smartphone className="h-3 w-3 text-emerald-600" />iOS & Android</span>
          </div>
          {isMobile && (
            <Link
              to="/m/scan"
              data-testid="mobile-scan-promo-link"
              className="mt-3 inline-flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors"
            >
              <Camera className="h-4 w-4" />
              Jetzt scannen
            </Link>
          )}
        </div>

        {/* QR-Code (Desktop) */}
        {!isMobile && (
          <div className="bg-white rounded-lg p-2 border border-emerald-200 shrink-0" data-testid="mobile-scan-promo-qr">
            <QRCodeSVG value={url} size={88} />
            <div className="text-[9px] text-slate-500 text-center mt-1 font-medium">
              QR scannen
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
